import { Button } from "@devhop/ui";
import { useNavigate } from "@tanstack/react-router";
import { HelpCircle, PlusIcon } from "lucide-react";

type KPIToolbarProps = {
  onCreate?: () => void;
  canCreate: boolean;
  onStartTour?: () => void;
};

export function KPIToolbar({
  onCreate,
  canCreate,
  onStartTour,
}: KPIToolbarProps) {
  const nav = useNavigate({ from: "/app/kpis" });

  const handleCreate = () => {
    if (onCreate) {
      onCreate();
    } else {
      nav({ to: "/app/kpi/create" });
    }
  };

  return (
    <div className="mb-2 flex flex-col gap-4">
      <div className="flex flex-wrap items-center justify-between space-y-2">
        <div>
          <div className="flex items-center space-x-2">
            <h2 className="font-bold text-2xl tracking-tight">ລາຍການ KPI</h2>

            <Button
              variant="ghost"
              size="icon"
              className="size-7 rounded-full"
              onClick={onStartTour}
            >
              <HelpCircle className="size-5" />
            </Button>
          </div>
          <p className="text-muted-foreground">
            ຈັດການຕົວຊີ້ວັດຜົນການປະຕິບັດງານ (KPI) ຂອງອົງກອນ.
          </p>
        </div>
        {canCreate && (
          <div className="flex items-center space-x-2">
            <div data-tourid="kpi-toolbar">
              <Button onClick={handleCreate}>
                <PlusIcon className="h-4 w-4" />
                ສ້າງ KPI
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
